import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {User} from '../../models/user';
import {environment} from '../../environments/environment';
import {ObjectUtils} from '../utils/object.utils';

@Injectable()
export class BaseService {
  protected env = environment;
  constructor(protected http: HttpClient) {
  }

  getEndPoints(url) {
    return `${this.env.apiHost}${url}`;
  }

  getPDFEndPoints(url) {
    return `${this.env.pdfApiHost}${url}`;
  }

  get(url, options = {}): Observable<any> {
    const apiUrl = this.getEndPoints(url);
    const params = {params: options, headers: this.updateHeaders()};
    return this.http.get(apiUrl, params);
  }

  getPDF(url, options = {}): Observable<any> {
    const apiUrl = this.getPDFEndPoints(url);
    const params = {params: options};
    return this.http.get(apiUrl, params);
  }

  getImage(url, options = {}): Observable<Blob> {
    let _headers = new HttpHeaders();
    _headers = _headers.set('Content-Type', 'image/jpeg');

    _headers = this.updateAuthorizationToken(_headers);
    const apiUrl = this.getEndPoints(url);
    return this.http.get(apiUrl, {responseType: 'blob', headers: _headers, params: options});
  }

  getBlob(url, options = {headers: {}, params: {}}): Observable<Blob> {
    let _headers = new HttpHeaders();
    if (options.headers) {
      for (const key in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, key)) {
          const value = options.headers[key];
          _headers = _headers.set(key, value);
        }
      }
    }

    _headers = this.updateAuthorizationToken(_headers);
    const apiUrl = this.getEndPoints(url);
    return this.http.get(apiUrl, {responseType: 'blob', headers: _headers, params: options.params});
  }

  post(url, postData: any, options = {}): Observable<any> {
    const apiUrl = this.getEndPoints(url);
    const _options = this.updateOptions(options);
    return this.http.post(apiUrl, postData, _options);
  }

  put(url, postData: any, options = {}): Observable<any> {
    const apiUrl = this.getEndPoints(url);
    const _options = this.updateOptions(options);
    return this.http.put(apiUrl, postData, _options);
  }

  public postRaw(url, postData: any, options: any = {}): Observable<any> {
    const apiUrl = this.getEndPoints(url);
    const _headers = new HttpHeaders(options.headers);

    options.headers = this.updateAuthorizationToken(_headers);
    return this.http.post(apiUrl, postData, options);
  }

  public delete(url, options: any = {}): Observable<any> {
    const apiUrl = this.getEndPoints(url);
    const headers = new HttpHeaders();
    const params = {params: options, headers: this.updateAuthorizationToken(headers)};

    return this.http.delete(apiUrl, params);
  }

  private updateOptions(options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  }) {

    options.headers = this.updateHeaders(options.headers);

    return options;
  }

  private updateHeaders(headers?): HttpHeaders {

    let _headers = new HttpHeaders(headers);
    _headers = _headers.set('Content-Type', 'application/json');

    return this.updateAuthorizationToken(_headers);
  }

  /**
   * update authorization token in header request
   * @param {HttpHeaders} header
   * @returns {HttpHeaders}
   */
  private updateAuthorizationToken(header: HttpHeaders) {
    if (localStorage.getItem('user') !== undefined) {
      const user = ObjectUtils.parseJSON(localStorage.getItem('user')) as User || false;
      if (user) {
        header = header.set('Authorization', user.token);
      }
    }
    return header;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/base.service.ts